export default "__VITE_PUBLIC_ASSET__035a23f2__"